export type LocalizationValues = {
    [key in LocalizedText]: string
}

export enum LocalizedText {
    ConditionLabel = 'CONDITIONLABEL',
    CriteriaEngine = 'CRITERIAENGINE',
    SetupConditions = 'SETUPCONDITIONS',
    Back = 'BACK',
    Cancel = 'CANCEL',
    Next = 'NEXT',
    From = 'FROM',
    TO = 'TO',
    IF = 'IF',
    On = 'ON',
    Save = 'SAVE',
    Confirm = 'CONFIRM',
    CancelOfferForm = 'CANCELOFFERFORM',
    UnsavedChanges = 'UNSAVEDCHANGES',
    SaveAsDraft = 'SAVEASDRAFT',
    ConfigureConditionsDesc = 'CONFIGURECONDITIONSDESCRIPTION',
    DeleteGroupCondition = 'DELETEGROUPCONDITION',
    AddGroupCondition = 'ADDNEWCONDITIONGROUP',
    AddNewSubCondition ='ADDNEWSUBCONDITION',
    SelectFieldType = 'ADMINSELECTFIELDTYPE',
    FieldValue = 'ADMINFIELDVALUE',
    SelectFieldValue = 'ADMINSELECTFIELDVALUE',
    NoResults = 'ADMINNORESULTS',
    ValueLabel = 'ADMINVALUELABEL',
    AndLabel = 'ADMINANDLABEL',
    ErrorSaveAsDraft = 'ADMINERRORSAVEASDRAFT',
    InvalidForm = 'ADMINCRITERIAINVALIDFORM',
    SuccessSaveAsDraft = 'ADMINCRITERIASAVEASDRAFTSUCCESS',
    SkipThisStep = 'ADMINCRTIERIASKIPTHISSTEP',

    OperatorAnd = 'ADMINOPERATORAND',
    OperatorOr = 'ADMINOPERATOROR',

    OperatorGreaterThan = 'ADMINOPERATORGREATERTHAN',
    OperatorLessThan = 'ADMINOPERATORLESSTHAN',
    OperatorEqual = 'ADMINOPERATOREQUAL',
    OperatorNotEqual = 'ADMINOPERATORNOTEQUAL',
    OperatorBetween = 'ADMINOPERATORBETWEEN',
    OperatorNotBetween = 'ADMINOPERATORNOTBETWEEN',
    OperatorAny = 'ADMINOPERATORANY',
    OperatorNone = 'ADMINOPERATORNONE',
    OperatorSpecificDate = 'ADMINOPERATORSPECIFICDATE',
    OperatorCustomRange = 'ADMINOPERATORCUSTOMRANGE',
    OperatorBefore = 'ADMINOPERATORBEFORE',
    OperatorAfter = 'ADMINOPERATORAFTER',
}